
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
export default {
components: {
XInput,
Group,
Cell ,
Flexbox,
FlexboxItem,
XImg ,
XButton,
Alert,
loadPage,

},
data(){
return{
username:'',
headimgurl:'',
communityName:'',
houseInfo:'',
show:false,
userphone:'',
phoneback:'',
comnCodes:'',
bgimgurl:global.imgUrl + '/image/bg.jpg',

balance:'',
expiration:'',
fontcolor:''
}
},
beforeMount(){
this.show_1 = true;
if(this.$router.history.current.path == "/user"){
document.title = "个人中心";
}
if(this.$router.history.current.query.phone){
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
if(res.body.result){
let data = res.body.result[0];
console.log("接口获取数据   ===   "+JSON.stringify(data));
this.communityName = data.comName;
this.houseInfo = data.hsNo;
this.userphone = data.mainPhone;
let phone = this.userphone;
this.comnCodes = data.comn_code;
this.phoneback = phone.substring(0,3) + '****' + phone.substring(7,11);
this.headimgurl = data.photoUrl
this.username = data.name;
this.$http.get(global.host + 'pay/findmonexpiredate?comnCode='+ data.comn_code + '&houseCode=' + data.hsNo).then(function (result) {
console.log(result)
this.balance = result.body.accountbalance;
this.expiration = result.body.lastdate;
let date = new Date(this.expiration.split('-')[0],this.expiration.split('-')[1],this.expiration.split('-')[2],23,59,59)
let curday = new Date()
if(Date.parse(date) - Date.parse(curday) >= 0){
this.fontcolor = '#333333';
}else{
this.fontcolor = 'red';
}
console.log(this.fontcolor)
this.expiration = dateFormat(new Date(this.expiration.split('-')[0],this.expiration.split('-')[1]-1,this.expiration.split('-')[2]),'YYYY/MM/DD')
},function (err) {
console.log(err)
})
}
this.show_1 = false;
},function(err){
console.log(err)
})
}else if(this.$router.history.current.query.userinfo){
let data = JSON.parse(this.$router.history.current.query.userinfo)
console.log("不知道哪里获取数据   ===   "+JSON.stringify(data));
this.username = data.wxName
this.headimgurl = data.photoUrl
this.communityName = data.comName;
this.houseInfo = data.buildName + '  ' + data.hsNo;
this.userphone = this.$router.history.current.query.phone = data.mainPhone;
let phone = this.userphone;
this.phoneback = phone.substring(0,3) + '****' + phone.substring(7,11);
this.$router.history.current.query.openid = data.openId;
}
},
methods:{
shouAlert(){
this.show = true;
}
}
}



// WEBPACK FOOTER //
// ./src/components/userComponents/user.vue